import React, { useState, useEffect } from 'react';
import { Flame, Zap, Gem, Rocket, Sparkles } from 'lucide-react';

const Topbar = () => {
  const messages = [
    { icon: Flame, text: "BACK IN STOCK - FAN FAVORITES SELLING FAST" },
    { icon: Zap, text: "LOW INVENTORY - BESTSELLERS ALMOST GONE" },
    { icon: Gem, text: "NEW ARRIVALS - EXCLUSIVE DROP JUST LANDED" },
    { icon: Rocket, text: "EXPRESS WORLDWIDE SHIPPING - 3-6 DAYS" },
    { icon: Sparkles, text: "10K+ HAPPY CUSTOMERS - JOIN THE HYPE" }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsAnimating(true);
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % messages.length);
        setIsAnimating(false);
      }, 500);
    }, 3500);

    return () => clearInterval(interval);
  }, [messages.length]);

  const CurrentIcon = messages[currentIndex].icon;

  return (
    <div className="bg-gradient-to-r from-black via-gray-900 to-black text-white overflow-hidden relative">
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent animate-pulse"></div>
      <div className="container mx-auto px-4 py-3 relative z-10">
        <div className="text-center relative h-5 overflow-hidden">
          <div
            className={`absolute inset-0 flex items-center justify-center gap-2 transition-all duration-500 ${
              isAnimating 
                ? 'opacity-0 translate-y-5' 
                : 'opacity-100 translate-y-0'
            }`}
          >
            <CurrentIcon className="w-4 h-4 sm:w-5 sm:h-5 text-orange-500 flex-shrink-0" />
            <span className="text-xs sm:text-sm font-bold tracking-wide">
              {messages[currentIndex].text}
            </span>
          </div>
        </div>
      </div>
      
      <div className="h-[2px] w-full bg-gradient-to-r from-transparent via-orange-500 to-transparent"></div>
    </div>
  );
};

export default Topbar;
